export default __webpack_public_path__ + "static/media/ios.715cce0e.svg";